module.exports = __webpack_public_path__ + "img/63.adb7b4db.jpg";